import { WebStorageStateStore } from 'oidc-client-ts';

import { STORAGE_KEYS } from '@/constants';

import type { AuthProviderProps } from 'react-oidc-context';

export const oidcConfig: AuthProviderProps = {
  authority: import.meta.env.VITE_AUTH_AUTHORITY,
  client_id: import.meta.env.VITE_AUTH_CLIENT_ID,
  ...(import.meta.env.VITE_AUTH_CLIENT_SECRET ? { client_secret: import.meta.env.VITE_AUTH_CLIENT_SECRET } : {}),
  redirect_uri: window.location.origin,
  post_logout_redirect_uri: window.location.origin,
  staleStateAgeInSeconds: 3600,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true,
  onSigninCallback: () => {
    window.localStorage.removeItem(STORAGE_KEYS.MAPPING_MODAL_CLOSED_KEY);
    window.history.replaceState({}, '', window.location.pathname);
  },
};
